// StatusBadge Component - Visual status indicators

import styles from './StatusBadge.module.css';

type StatusVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral';

interface StatusBadgeProps {
  variant?: StatusVariant;
  children: React.ReactNode;
  pulse?: boolean;
  className?: string;
}

export function StatusBadge({
  variant = 'neutral',
  children,
  pulse = false,
  className = '',
}: StatusBadgeProps) {
  return (
    <span className={`${styles.badge} ${styles[variant]} ${pulse ? styles.pulse : ''} ${className}`}>
      {pulse && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
}
